import { ICourseNameList } from 'models/course.model'
import api from '../..'

// Trae id y nombre de todos los cursos
const getCourseNamesList = () => {
  return api.get(`/administration/courses/list`).then(({ data: { data } }) => {
    return data.map(
      ({ attributes: { id, name, profiles } }: any): ICourseNameList => {
        return { id, name, profiles }
      }
    )
  })
}

export default getCourseNamesList
